<template>
  <div class="error">
    订单不存在，请联系商家
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
.error{
  padding:8vw;
  color:crimson;
}
</style>
